export const LANG_OPTIONS = [
  { value: 'javascript', label: 'JavaScript' },
  { value: 'typescript', label: 'TypeScript' },
  { value: 'vue3',       label: 'Vue 3' },
  { value: 'vue2',       label: 'Vue 2' },
  { value: 'html',       label: 'HTML' },
  { value: 'css',        label: 'CSS' },
  { value: 'postgresql', label: 'PostgreSQL' },
]

export const PREVIEW_LANGS = ['javascript', 'typescript', 'vue3', 'vue2', 'html', 'css', 'postgresql']

export const langConfigs = {
  javascript: {
    activeEditor: 'script',
    markup: { language: 'html',       content: '', hideTitle: true },
    style:  { language: 'css',        content: '', hideTitle: true },
    script: {
      language: 'javascript',
      content: `// Hello JavaScript!\nconsole.log('Hello, World!');`,
    },
    tools: { status: 'open' },
  },

  typescript: {
    activeEditor: 'script',
    markup: { language: 'html',       content: '', hideTitle: true },
    style:  { language: 'css',        content: '', hideTitle: true },
    script: {
      language: 'typescript',
      content: `// Hello TypeScript!\nconst message: string = 'Hello, World!';\nconsole.log(message);`,
    },
    tools: { status: 'open' },
  },

  vue3: {
    editor: 'monaco',
    activeEditor: 'markup',
    markup: {
      language: 'vue',
      title: 'Vue 3',
      content: `<template>\n  <div>\n    <h1>{{ message }}</h1>\n  </div>\n</template>\n\n<script setup>\nimport { ref } from 'vue'\n\nconst message = ref('Hello Vue 3!')\n<\/script>`,
    },
    style:  { language: 'css',        content: '', hideTitle: true },
    script: { language: 'javascript', content: '', hideTitle: true },
    autoupdate: true,
    tools: { status: 'closed' },
  },

  vue2: {
    editor: 'monaco',
    activeEditor: 'markup',
    markup: {
      language: 'vue2',
      title: 'Vue 2',
      content: `<template>\n  <div>\n    <h1>{{ message }}</h1>\n  </div>\n</template>\n\n<script>\nexport default {\n  data() {\n    return { message: 'Hello Vue 2!' }\n  }\n}\n<\/script>`,
    },
    style:  { language: 'css',        content: '', hideTitle: true },
    script: { language: 'javascript', content: '', hideTitle: true },
    customSettings: { vue: '2' },
    autoupdate: true,
    tools: { status: 'closed' },
  },

  html: {
    activeEditor: 'markup',
    markup: {
      language: 'html',
      content: `<!DOCTYPE html>\n<html lang="en">\n<head>\n  <meta charset="UTF-8">\n  <title>Document</title>\n</head>\n<body>\n  <h1>Hello HTML!</h1>\n</body>\n</html>`,
    },
    style:  { language: 'css',        content: '', hideTitle: true },
    script: { language: 'javascript', content: '', hideTitle: true },
    tools: { status: 'closed' },
  },

  css: {
    activeEditor: 'style',
    markup: {
      language: 'html',
      content: '<div class="box">Hello CSS!</div>',
      hideTitle: true,
    },
    style: {
      language: 'css',
      content: `.box {\n  padding: 20px;\n  background: #4DB39E;\n  color: white;\n  border-radius: 8px;\n  text-align: center;\n}`,
    },
    script: { language: 'javascript', content: '', hideTitle: true },
    tools: { status: 'closed' },
  },

  postgresql: {
    activeEditor: 'script',
    markup: { language: 'html',       content: '', hideTitle: true },
    style:  { language: 'css',        content: '', hideTitle: true },
    script: {
      language: 'pgsql',
      content: `-- Hello PostgreSQL!\nSELECT 'Hello, World!' AS message;`,
    },
    tools: { status: 'open', active: 'console' },
  },
}

export const vue3Config = langConfigs.vue3

export const activeEditorMap = {
  javascript: 'script',
  typescript: 'script',
  vue3:       'markup',
  vue2:       'markup',
  html:       'markup',
  css:        'style',
  postgresql: 'script',
}
